// extracted by mini-css-extract-plugin
export default {"block":"styles_block__tUa4y","header":"styles_header__ETyzF","title":"styles_title__QCeXC"};